export const publicationSubRoute = {
  list: "list",
} as const;

export interface PublicationGroupsRoutes {
  sub: typeof publicationSubRoute.list;
  method?: "Get";
}
